<template lang="">
	<span
		v-if="e"
	>
		<div
			class="d-flex flex-wrap flex-sm-nowrap mb-4"
		>
			<MatInput
				dense
				v-model="e.title"
				class=" me-0 me-sm-3 w-100 w-sm-50 mb-4 mb-sm-0"
				:label="$t('exp.post')"
				:class="{'pe-none': makeDisabled}"
			/>
			<MatInput
				:class="{'pe-none': makeDisabled}"		
				dense
				v-model="e.institution"
				:label="$t('exp.entreprise')"
				class=" me-0 me-sm-3 w-100 w-sm-50 "
			/>
		</div>
		
		<div class="d-flex flex-wrap flex-sm-nowrap">
			<div
				class="w-100 w-sm-50 me-0 me-sm-3 mb-4 mb-sm-0"
			>
				<MatDatepicker
					dense
					v-model="e.start"
					class=""
					:label="$t('exp.debut')"
					monthPicker="true"
					:class="{'pe-none': makeDisabled}"
				/>
				<MatDatepicker
					v-if="!e.still"
					dense
					v-model="e.end"
					class="mt-3"
					:label="$t('exp.fin')"
					monthPicker="true"
					:class="{'pe-none': makeDisabled}"
				/>
			</div>
			<div
				class="flex-vertical-center w-100 w-sm-50  me-0 me-sm-3"
			>
				<MatCheckbox
					v-model="e.still"
					:class="{'pe-none': makeDisabled}"
				/>
				<label class="body1 txt-secondary">{{ $t('exp.postActuelle') }}</label>
			</div>
		</div>
	</span>
</template>
<script>
export default {
	emits: ['openMonthPicker'],
	data(){
		return {
			e: null
		}
	},
	watch: {
	},
	props:{
		data:{
			type: Object,
			default: () => null
		},
		disabled:{
			type: Boolean,
			default: true
		},
	},
	computed: {
		makeDisabled(){
			return this.disabled && this.$route.name=='userDetail'
		}
	},
	methods:{
		stillChange(e){
			e.still = !e.still;
			if(e.still) e.end = null;
			else e.end = new Date()
		},
	},
	mounted() {
		this.e = this.data
	},
}
</script>
<style lang="scss" scoped>
  @media (min-width: 768px) {
  .w-sm-50 {
    width: 50% !important;
  }
}
</style>